import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

const ScrollToTop = props => {
    const { location, children } = props
    const pathname = location?.pathname

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return children
}

ScrollToTop.propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
}

export default withRouter(ScrollToTop)
